<template>
  <v-card
    :loading="loading"
    class="mx-auto my-2"
    min-height="250px;"
  >
    <v-card-title>General PO Information</v-card-title>
    <v-card-text style="font-size: 1rem;">
      <div v-if="!salesData" style="text-align: center;">No Data</div>
      <v-row v-else>
        <v-col cols="4">
          <b>Invoice No.:</b> {{ salesData.invoiceno }}
        </v-col>
        <v-col cols="4">
          <b>Invoice Date:</b> {{ salesData.invoicedate }}
        </v-col>
        <v-col cols="4">
          <b>Customer Name:</b> {{ salesData.customername }}
        </v-col>
        <v-col cols="4">
          <b>FG Code:</b> {{ salesData.fgcode }}
        </v-col>
        <v-col cols="4">
          <b>PO Date: </b> {{ salesData.podate }}
        </v-col>
        <v-col cols="4">
          <b>Contract No.:</b> {{ salesData.contractno }}
        </v-col>
        <v-col cols="4">
          <b>Contract Date:</b> {{ salesData.contractdate }}
        </v-col>
        <v-col cols="4">
          <b>Business Category:</b> {{ salesData.businesscategory }}
        </v-col>
        <v-col cols="4">
          <b>Location:</b> {{ salesData.location }}
        </v-col>
        <v-col cols="4">
          <b>Product:</b> {{ salesData.product }}
        </v-col>
        <v-col cols="4">
          <b>Model:</b> {{ salesData.model }}
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: ['loading', 'salesData'],
  data() {
    return {};
  },
};
</script>
